import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  signal,
} from '@angular/core';

import { FileUploadService } from '../../../../core/services/file-upload.service';

@Component({
  selector: 'app-step-expedite-request',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
  templateUrl: './step-expedite-request.component.html',
  styleUrls: ['./step-expedite-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepExpediteRequestComponent implements OnInit {
  private readonly fileUploadService = inject(FileUploadService);

  /**
   * Pre-set from file content (SLA flag in record 01 of CP file).
   * User can still override the selection.
   */
  isExpedited = signal(false);

  ngOnInit(): void {
    this.isExpedited.set(this.fileUploadService.slaFromFiles);
  }

  selectOption(expedited: boolean): void {
    this.isExpedited.set(expedited);
  }

  canProceed(): boolean {
    return true;
  }
}
